import React, { useState, useEffect } from 'react';
import { PublicClientApplication } from '@azure/msal-browser';
import './Components.css';
import { msalInstance } from '../utils/AuthUtilities';
import { ISDLClientID } from '../isdlData/isdlData';

//MSAL config moved to utils/AuthUtilities.js

// Improved iOS detection
const isIOS = () => {
  const ua = navigator.userAgent || navigator.vendor || window.opera;
  return (/iPad|iPhone|iPod/.test(ua)) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
};

const SSO = ({ OnSSOFinished = () => {} }) => {
  const [initialized, setInitialized] = useState(false);
  const [account, setAccount] = useState(null);
  // This state controls whether to show the login button.
  const [showLoginButton, setShowLoginButton] = useState(false);

  // Helper function that updates sessionStorage and calls OnSSOFinished.
  const completeLogin = (account, token) => {
    if (token) {
      sessionStorage.setItem('authToken', token);
    }
    if (account && account.username) {
      sessionStorage.setItem('dataCollectorEmail', account.username);
    }
      OnSSOFinished(null, "PORTAL");
  };

  useEffect(() => {
    const initMsal = async () => {
      try {
        // Initialize MSAL
        await msalInstance.initialize();
        setInitialized(true);

        // Process any redirect response (if returning from a redirect login)
        const response = await msalInstance.handleRedirectPromise();
        if (response) {
          msalInstance.setActiveAccount(response.account);
          setAccount(response.account);
          completeLogin(response.account, response.accessToken);
        } else {
          // Check for a cached account.
          const cachedAccounts = msalInstance.getAllAccounts();
          if (cachedAccounts && cachedAccounts.length > 0) {
            msalInstance.setActiveAccount(cachedAccounts[0]);
            setAccount(cachedAccounts[0]);
            
            // // Try to acquire a valid token silently
            try {
              const silentTokenResponse = await msalInstance.acquireTokenSilent({
                account: cachedAccounts[0],
                scopes: [`${ISDLClientID()}/.default`],
              });
              // If successful, complete login with the valid token.

              completeLogin(cachedAccounts[0], silentTokenResponse.accessToken);
            } catch (tokenError) {
              console.error("Silent token acquisition failed:", tokenError);
              // If acquiring a token fails, show the login button.
              setAccount(null);
              setShowLoginButton(true);
            }
          } else {
            // Attempt silent SSO if no cached account is found.
            try {
              const silentRequest = {
                scopes: [`${ISDLClientID()}/.default`],
                prompt: "none",
              };
              const silentResponse = await msalInstance.ssoSilent(silentRequest);
              if (silentResponse) {
                msalInstance.setActiveAccount(silentResponse.account);
                setAccount(silentResponse.account);
                completeLogin(silentResponse.account, silentResponse.accessToken);
              }
            } catch (silentError) {
              console.error("Silent login attempt failed:", silentError);
              // If silent login fails, show the login button.
              setAccount(null);
              setShowLoginButton(true);
            }
          }
        }
      } catch (error) {
        console.error("Error initializing MSAL:", error);
        // In case of any error during initialization, allow the user to login interactively.
        setAccount(null);
        setShowLoginButton(true);
      }
    };

    initMsal();
  }, [OnSSOFinished]);

  // Define the login request once so it's available immediately.
  const loginRequest = {
    scopes: [`${ISDLClientID()}/.default`],
  };

  // Handle login button click
  const handleLoginMSSSO = () => {
    try {
      console.log("Calling loginRedirect for iOS...");
      msalInstance.loginRedirect(loginRequest);
    } catch (error) {
      console.error("Error during loginRedirect:", error);
    }
  };

  return (
    <div>
      <div className='login-background' style={{backgroundImage: `url("/ecpc_bg2.jpg")`}}>

      </div>
      <div className='login'>
        <div className='login-window'>
          {account ? (
                // User is logged in: display welcome message.
                <div style={{display:'flex', flexDirection:'column'}}>
                  <span style={{fontSize:'22px', fontWeight:'bold', marginBottom:'10px'}}>Welcome, {account.username}!</span>
                  <span>You are now logged in.</span>
                  <span>App will begin shortly.</span>
                </div>
              ) : (
                // User is not logged in: show login button only if silent login failed.
                <div style={{display:'flex', flexDirection:'column'}}>
                  <span style={{fontSize:'22px', fontWeight:'bold', marginBottom:'10px'}}>Please log in</span>
                  {!initialized && <span>Initializing authentication...</span>}
                  {initialized && !showLoginButton && <span>Logging in...</span>}
                  {initialized && showLoginButton && (
                    <button type="button" className='button' onClick={handleLoginMSSSO}>
                      Login with SSO
                    </button>
                  )}
                </div>
              )}
        </div>
      </div>
    </div>
  );
};

export default SSO;
